import { render } from "./App.vue?vue&type=template&id=3e4064fe"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3e4064fe&lang=scss"

import exportComponent from "E:\\web-workspace\\xiaomodou-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__